import { FC, useContext } from 'react';
import { ObjectPageContext } from '../../../pages/Context/ObjectPageContext';
import moment from 'moment';
import { BidDto } from '~js/React/services/generatedApi';

const BiddingHistory: FC = () => {
  const { estate } = useContext(ObjectPageContext);
  let listOfStoppedBidders: Array<string> = new Array<string>();
  let newDate = new Date();

  const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
  const date = newDate.getDate();
  const month = newDate.getMonth() + 1;
  const yesterdayDate = yesterday.getDate();
  const yesterdayMonth = yesterday.getMonth() + 1;
  return (
    <div className="lg:bg-blue700 px-6 lg:px-0 pb-4 lg:text-white">
      <hr className="border-t-1 border-white lg:hidden" />
      <div className="justify-between flex mb-1 mdplus:text-tiny xl:text-base font-icb">
        <span className="w-1/3 lg:w-2/5 ">Bud</span>
        <span className="w-1/5 lg:w-1/4">Datum</span>
        <span className="w-1/5">Tid</span>
        <div className="w-1/5 text-right">
          <span className="">Budgivare</span>
        </div>
      </div>
      {estate?.bids &&
        estate?.bids !== undefined &&
        estate?.bids.map(
          (bid: BidDto) =>
            (bid?.status == 'Deltar' ||
              bid?.status == 'Stannat i budgivning') && (
              <div
                className="justify-between flex mb-2 mdplus:text-tiny xxl:text-base items-center"
                key={bid?.dateAndTime}
              >
                <span
                  className={`${
                    bid?.cancelled ? 'line-through' : ''
                  } w-1/3 lg:w-2/5`}
                >
                  {bid?.amount.toLocaleString('SV-se')} kr{' '}
                  <span className="text-tiny">
                    {bid?.status == 'Stannat i budgivning' &&
                    listOfStoppedBidders.indexOf(bid?.alias) == -1
                      ? '*'
                      : ''}
                  </span>
                </span>
                {bid?.status == 'Stannat i budgivning' && (
                  <span className="hidden">
                    {listOfStoppedBidders.push(bid?.alias)}
                  </span>
                )}
                <span
                  className={`${
                    bid?.cancelled ? 'line-through' : ''
                  } w-1/5 lg:w-1/4`}
                >
                  {moment(bid?.dateAndTime).format('DD') ==
                    yesterdayDate.toString() &&
                  moment(bid?.dateAndTime).format('M') ==
                    yesterdayMonth.toString()
                    ? 'Igår'
                    : moment(bid?.dateAndTime).format('DD') ==
                        date.toString() &&
                      moment(bid?.dateAndTime).format('M') == month.toString()
                    ? 'Idag'
                    : moment(bid?.dateAndTime).format('D') +
                      '/' +
                      moment(bid?.dateAndTime).format('M')}
                </span>
                <span
                  className={`${bid?.cancelled ? 'line-through' : ''} w-1/5`}
                >
                  {moment(bid?.dateAndTime).format('HH:mm')}
                </span>
                <div className="w-1/5 text-right">
                  <div className="xl:w-6 xl:h-6 w-6 h-6 lg:w-5 lg:h-5 font-icb lg:font-ic text-xs xl:text-tiny lg:bg-white border-2 border-blue700 lg:border-0 text-blue700 rounded-full ml-auto text-center">
                    <span className="align-middle">{bid?.alias}</span>
                  </div>
                </div>
              </div>
            )
        )}
      {listOfStoppedBidders.length > 0 && (
        <p className="mt-4 mb-0 text-tiny">* Stannat i budgivning</p>
      )}
    </div>
  );
};
export default BiddingHistory;
